module.exports = __webpack_public_path__ + "static/undraw_hiring_cyhs.36c688d6.svg";


//////////////////
// WEBPACK FOOTER
// /Users/stephan/skelware/savot/public/images/undraw/undraw_hiring_cyhs.svg
// module id = 508
// module chunks = 0